import { t } from "i18next";
import { clearConfigCache } from "prettier";
import React, { RefObject, useEffect, useRef, useState } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

interface props {
  mainItem: {
    item: string;
    path: string;
    displayName: string;
    icon: JSX.Element;
    subItems: {
      item: string;
      displayName: string;
      path: string;
      icon: JSX.Element;
      subItems: {
        item: string;
        displayName: string;
        path: string;
      }[];
    }[];
  };
}

const LeftSideBarSubItem: React.FC<props> = ({ mainItem }) => {
  const menuRef: RefObject<HTMLDivElement> = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  const navigate = useNavigate();
  const navigateTo = (nav: string) => {
    const params = Object.fromEntries(searchParams.entries());

    navigate(
      {
        pathname: `bvoice/${nav}`,
        //this condition is to clear searchparams when swithcing from agent  report to queue reports
        search: location?.pathname?.split("/")?.includes(nav.split("/")[2])
          ? `${new URLSearchParams(params).toString()}`
          : undefined,
      },
      { replace: true }
    );
  };
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const handleClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    path?: string
  ) => {
    e.stopPropagation();
    if (path) {
      navigateTo(path);
    }
  };

  const handleClickOutside = (event: MouseEvent) => {
    const target = event?.target as HTMLDivElement;
    const id = target?.id;
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target as Node) &&
      id !== "leftSidebar-menu"
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside as EventListener);
    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside as EventListener
      );
    };
  }, []);

  return (
    <div ref={menuRef} id="leftSidebar-menu" className="relative">
      <div
        onClick={(e) => {
          setIsOpen(!isOpen);
        }}
        className="flex items-center   justify-start gap-2 "
      >
        <div className="text-primary ">{mainItem.icon}</div>
        <span className="hidden xl:inline">
          {t(mainItem.displayName) as string}
        </span>
        <svg
          id="options-menu"
          className={`duration-150 flex-shrink-0 hidden xl:inline ${isOpen ? " block -rotate-90 " : " -rotate-270"}  ml-auto  h-5 w-5`}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M5.23 7.21a.75.75 0 011.06 0L10 10.88l3.71-3.67a.75.75 0 111.06 1.06l-4.25 4.2a.75.75 0 01-1.06 0l-4.25-4.2a.75.75 0 010-1.06z"
            clipRule="evenodd"
          />
        </svg>
      </div>
      <div
        className={`${isOpen && mainItem?.subItems ? "grid-rows-[1fr] " : "transition-grid  "} absolute   bg-blend-luminosity rounded-md -top-2 left-8 xl:left-[200px] z-[9999]  grid grid-rows-[0fr] bg-primary-alpha-20 backdrop-blur-lg duration-200`}
      >
        <div className="w-max ml-auto overflow-hidden">
          {mainItem?.subItems?.map((child, index) => {
            console.log("childddss", child);
            return (
              <CollapsibleMenuItem
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                handleClick={handleClick}
                subItem={child}
                key={index}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LeftSideBarSubItem;

const CollapsibleMenuItem = ({
  subItem,
  handleClick,
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleClick: (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    path?: string
  ) => void;
  subItem: {
    item: string;
    displayName: string;
    path: string;
    icon: JSX.Element;
    subItems: {
      item: string;
      displayName: string;
      path: string;
    }[];
  };
}) => {
  const [isQueueOpen, setisQueueOpen] = useState(false);
  const location = useLocation();
  return (
    <div className=" w-full ml-auto overflow-hidden ">
      <div
        className={` duration-150 flex flex-col items-center justify-between p-3  `}
      >
        <div
          onClick={() => {
            setisQueueOpen(!isQueueOpen);
          }}
          className={`flex ${location?.pathname.split("/")[4] === subItem?.displayName?.toLowerCase() ? "bg-primary-alpha-40    " : "bg-primary-alpha-20"} items-center gap-2  p-2 rounded-md w-full`}
        >
          <span className="text-primary">{subItem?.icon}</span>
          {subItem?.displayName}
          <svg
            id="options-menu"
            className={`duration-150 flex-shrink-0 ${isQueueOpen ? "block -rotate-90 " : " -rotate-270 "}   h-5 w-5 ml-auto`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M5.23 7.21a.75.75 0 011.06 0L10 10.88l3.71-3.67a.75.75 0 111.06 1.06l-4.25 4.2a.75.75 0 01-1.06 0l-4.25-4.2a.75.75 0 010-1.06z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <div
          className={`text-sm  ${isQueueOpen ? "grid-rows-[1fr]  " : "transition-grid grid-rows-[0fr] "} grid  duration-200  w-full ml-auto `}
        >
          <div className={`overflow-hidden first:pt-2 } `}>
            {subItem?.subItems?.map((node, index: number) => {
              console.log(
                "locationPathname: ",
                location?.pathname?.split("/")?.slice(2)?.join("/")
              );

              return (
                <div
                  onClick={(e) => {
                    setIsOpen(!isOpen);
                    handleClick(e, node?.path);
                  }}
                  className={`p-2 rounded-md hover:bg-primary-alpha-20
                    ${location?.pathname?.split("/")?.slice(2)?.join("/") === node?.path ? "bg-primary-alpha-40" : ""}
                    
                     `}
                >
                  {node?.displayName}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
